import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Config } from "constant";
import Modal from "module-common/Modal";
import Button from "module-common/Button";
import Input from "module-common/Input";
import { ShowNotice, AnalyticStore } from "Store";
import NotificationBox from "module-common/NotificationBox";
import { graphql, compose } from "react-apollo";
import { mutationDownloadReport } from "Apollo";

export default compose(graphql(mutationDownloadReport, { name: "download" }))(
  class ConfirmModal extends Component {
    static propTypes = {
      text: PropTypes.string,
      onCancel: PropTypes.func,
      onConfirm: PropTypes.func,
      isConfirmLoading: PropTypes.bool
    };
    static defaultProps = {
      isConfirmLoading: false
    };
    state = {
      email: ""
    };
    render() {
      const {
        text,
        onCancel,
        isConfirmLoading,
        onConfirm,
        dateStart
      } = this.props;
      const { email } = this.state;
      return (
        <Modal>
          <Wrapper>
            <Text>{text}</Text>
            <Input
              label="Email"
              name="email"
              placeholder="abc@xyz.com"
              value={email}
              onChange={e => this.setState({ email: e.target.value })}
            />
            <br />
            <Buttons>
              <Button
                width={100}
                onClick={onCancel}
                color="gray"
                disabled={isConfirmLoading}
              >
                Cancel
              </Button>
              <Button
                width={100}
                onClick={this.onConfirm}
                loading={isConfirmLoading}
                disabled={isConfirmLoading}
              >
                Send
              </Button>
            </Buttons>
          </Wrapper>
        </Modal>
      );
    }

    onConfirm = e => {
      e.preventDefault();
      const { email } = this.state;
      const onConfirm = this.props.onConfirm;
      if (email === "") {
        ShowNotice("download-report-error");
      } else {
        this.props.download({
          variables: {
            email: email,
            startTime: AnalyticStore.startTime.format("YYYY-MM-DD"),
            endTime: AnalyticStore.endTime.format("YYYY-MM-DD")
          }
        });

        ShowNotice("download-report-success");
        onConfirm(this.state.email);
      }
    };
  }
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
`;
const Text = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 1rem;
  text-align: center;
  margin-bottom: 20px;
`;
const Buttons = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  & > *:first-child {
    margin-right: 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/module-common/DownloadModal.js